<div id="notification" [class]="active ? 'active' : ''" [dir]="currentLang.dir">
    <div id="notification-content">
        <div id="notification-message">
            <span>{{message || currentLang.words["notification-txt"]}} <a (click)="goToLeadClient()" routerDirection="forward"
                    (click)="close();">{{currentLang.words["notification-link"]}}</a></span>
        </div>
    </div>
    <div id="notification-close" (click)="close();"><span></span></div>
</div>